/**
 * `person` — the single-assignee legacy column. The sandbox board has none, so the list is
 * `people`'s (the two are the same picker with a cardinality of one) and is marked as
 * **inferred, not measured** in `specs/M1-B6-filters-sort.md` §3.
 */
import { peopleFilterConditions } from '../people/filters.js';
export const personFilterConditions = peopleFilterConditions;
//# sourceMappingURL=filters.js.map